export default __webpack_public_path__ + "static/media/cimb.fe43a63e.svg";